// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-change[data-v-06abac34]{align-items:center;display:flex}.edit-change>h5[data-v-06abac34]{flex:1}[data-v-06abac34] .edit-help code{padding:1px 5px}", ""]);
// Exports
module.exports = exports;
